export default __webpack_public_path__ + "static/media/greener-transport.17386e01.png";